module.exports = __webpack_public_path__ + "img/typhoon_32.c3e0937c.png";